/*
 * Funciones para procesar los datos devueltos por GET "api/bi"
 */

import { has, isFunction, isArray } from 'lodash'

// Auxiliary date functions
export const getMonthName = value => {
  switch (parseInt(value, 10)) {
    case 1: return 'Enero';
    case 2: return 'Febrero';
    case 3: return 'Marzo'
    case 4: return 'Abril'
    case 5: return 'Mayo'
    case 6: return 'Junio'
    case 7: return 'Julio'
    case 8: return 'Agosto'
    case 9: return 'Septiembre'
    case 10: return 'Octubre'
    case 11: return 'Noviembre'
    case 12: return 'Diciembre'
    default: return 'ERROR'
  }
}
export const currentYear = () => {
  return new Date().getFullYear();
}
export const currentMonth = () => {
  return new Date().getMonth() + 1;
}
// Auxiliary function
export const value = (path, obj) => {
  let array = path.toString().split('.');
  return array.reduce((xs, x) => (xs && xs[x]) ? xs[x] : 0, obj);
}


class DataLibrary {

  /**
   * Funcion que recorre el array y aplica una funcion ('reducer()') a cada item del mismo.
   */
  static reduceToObject(array, key, reducer){
    if(!isArray(array)){
      throw new Error("reduceToObject() function expect an array to loop!")
    }
    if(!isFunction(reducer)){
      throw new Error("reduceToObject() function expect a function as reducer!")
    }
    let retval = {};
    array.map((item, index) => {
      let id = isFunction(key)? key(item, index) : item[key];
      return retval[id] = reducer(item, index);
    })
    return retval;
  }

  /**
   * Filtro los datos por año/mes
   */
  static filterByYear(data, year, month){
    if(year===null || year === undefined){
      year = currentYear();
    }
    if(month===null || month === undefined){
      return data.filter(item => item.year===year );
    }
    return data.filter(item => item.year===year && item.month === month );
  }

  /**
   * Funcion que recorre el array y aplica una funcion ('reducer()') a cada item del mismo.
   * El resultado es agrupado en una key que devuelve la funcion 'group_by()'
   */
  static _reduceBy(data, reducer, group_by){
    if(group_by === null || group_by===undefined){
      throw new Error("Missing 'group_by' parameter in function _reduceAlt(data, config, group_by)");
    }
    const tmp = data.reduce((retval, item)=>{
      const groupBy = group_by(item);
      if(!has(retval,groupBy)){
        retval[groupBy] = {}
        for(let key in reducer){
          retval[groupBy][key] = 0;
        }
      }
      for(let key in reducer){
        const fn_reducer = reducer[key];
        retval[groupBy][key] = (retval[groupBy][key] || 0 ) + fn_reducer(item);
      }
      return retval;
    }, {});
    return tmp;
  }

  /**
   * Funcion complementaria de _reduceBy() que recore el array y lo aplana
   * Ademas genera la key 'name' a traves del callback 'fn_name()'
   */
  static _flat(data, fn_name){
    if(data.length === 0){ return data;}
    let retval = [];
    for(let index in data){
      const name = fn_name(data[index], index);
      const obj = Object.assign({}, data[index], {name});
      retval.push(obj);
    }
    return retval;
  }

  /**
   * Funcion que recorre el array y aplica una funcion ('reducer()') a cada item del mismo.
   * Similar a la funcion '_reduceBy()', pero no agrupa
   */
  static reduce(data, reducer){
    // proceso el array fila x fila a traves del reducer
    const tmp = data.reduce((retval, item)=>{
      for(let key in reducer){
        const fn_reducer = reducer[key];
        retval[key] = (retval[key] || 0 ) + fn_reducer(item);
      }
      return retval;
    }, {});
    let array = [];
    for(let key in tmp){
      array.push({
        name: key,
        value: tmp[key]
      })
    }
    return array;
  }

  /**
   * Recorro el array y lo reduce por mes
   */
  static reduceByMonth(data, reducer){
    const tmp = DataLibrary._reduceBy(data, reducer, item => item.month);
    return DataLibrary._flat(tmp, (row, index) => getMonthName(index));
  }

  /**
   * Recorro el array y lo reduce por genero (sexo)
   */
  static reduceByCompany(data, reducer){
    const tmp = DataLibrary._reduceBy(data, reducer, item => item.co);
    return DataLibrary._flat(tmp, (row, index) => index);
  }

  /**
   * Recorro el array y lo reduce por provincia
   */
  static reduceByProvince(data, reducer){
    const tmp = DataLibrary._reduceBy(data, reducer, item => item.provId);
    return DataLibrary._flat(tmp, (row, index) => index);
  }

}

export default DataLibrary;



// WEBPACK FOOTER //
// ./src/screens/biCharts/DataLibrary.js